import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';

export interface Chapter {
  id: string,
  title: string,
  _show: string,
  imageKey: string | null,
  content: string | null,
  imageLink: string,
  createdAt: number,
  updatedAt: number,
  children: [],
  _parent: string
}

export interface State {
  chapters:Chapter[],
  loading:boolean
}

const defaultState: State = {
  chapters:[],
  loading:false
};

const getters = {
  loading: (state: State) => state.loading,
  chapters: (state: State) => state.chapters,
}

const mutations: MutationTree<State> = {
  setChapters(state: State, payload: Chapter[]) {
    state.chapters = payload
  },
  setOneChapter(state: State, payload: Chapter) {
    const map = state.chapters.map((el:Chapter)=>{
      if(el.id === payload.id) return payload
      return el
    })
    state.chapters = map
  },
  setLoadStatus(state: State, payload: boolean) {
    state.loading = payload
  },
}

const actions: ActionTree<State, RootState> = {
  async loadChaptersFromServer({commit, state},payload:string) {
    commit('setLoadStatus', true)
    try {
      const {data} = await Vue.axios.get('/v4/show/'+payload+'/thematic')
      if(data.error){
        throw (data.error)
      }
      commit('setChapters', data.data)
      commit('setLoadStatus', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: ['Разделы загружены']
      })
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }
  },
  async saveChapterFromServer({commit, state},payload:any){
    const thematicId = payload.thematicId
    let params:any = {}
    if(payload.imageKey) {
      params = {imageKey:payload.imageKey, title:payload.title, _parent:payload.parentThematic, content: payload.content}
    } else {
      params = {title:payload.title, _parent:payload.parentThematic, content: payload.content}
    }
    
    try {
      const {data} = await axios.patch('/v4/show/thematic/'+ thematicId, params)
      commit('setOneChapter', data.data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: ['Тематика отредактирована']
      })
      return true
    }catch (e) {
return false

    }
  },
  async addChapterFromServer({commit, state},payload:any){
    const thematicId = payload.thematicId
    let params = {imageKey:payload.imageKey, _parent:payload.parentThematic, title:payload.title, content: payload.content}
    let code = payload.code

    try {
      const {data} = await axios.post('/v4/show/' + code + '/thematic', params)
      //commit('setOneChapter', data.data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: ['Тематика добавлена']
      })
      return true
    }catch (e) {
return false

    }
  },
  async deleteChapterFromServer({commit, state},payload:string) {
    try {
      const {data} = await axios.delete('/v4/show/thematic/' + payload)
      return true
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
      return false
    }
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
